module.exports = __webpack_public_path__ + "static/media/ic_proyectos_multimodal_pin_seleccionado.dcdbce81.svg";